import "./NetworkLogin.css";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import { networkLoginApi } from "../../../api/UtilsApi";
import Loader from "../../../components/organisms/loader/Loader";
import { useAuth } from "../../../context/AuthContext";
import FilledButton from "../../../components/molecules/buttons/filledButton/FilledButton";

function NetworkLogin() {
  const { networkParam, accountParam, keyParam } = useParams();
  const { setUuid } = useAuth();
  const { createNotification } = useContext(AppContext);
  const [loginError, setLoginError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    login();
  }, [networkParam, accountParam, keyParam]);

  async function login() {
    setLoginError(false);
    try {
      const res = (await networkLoginApi(getNetworkName(networkParam), accountParam, keyParam)).data;

      setUuid(res.uuid);
      setTimeout(() => {
        navigate("/mon-compte/mes-outils/mes-estimations", { replace: true });
      }, 500);
    } catch (error) {
      setLoginError(true);
      createNotification(
        <>Une erreur est survenue lors de la connexion. Veuillez réessayer.</>,
        "var(--red)",
        "var(--dark-blue)",
      );
    }
  }

  function getNetworkName(networkParam) {
    let tmp = networkParam.split("-");
    tmp.pop();

    return tmp.join();
  }

  return (
    <div className='page-container container'>
      <div className='network-login-container'>
        {loginError ? (
          <>
            <h1 className='network-login-title text-red'>
              Connexion impossible
              <br />
            </h1>
            <p className='mt-md text-lg'>
              Il semble qu'un problème soit survenu lors de votre authentification.
              <br />
              (Code erreur : XB1)
            </p>
            <FilledButton className='mt-md' fontSize='1.2rem' onClick={login} isLoading={!loginError}>
              Réessayer
            </FilledButton>
          </>
        ) : (
          <h1 className='network-login-title mb-lg'>
            En attente de connexion...
            <br />
            Veuillez patienter.
          </h1>
        )}
      </div>
      <Loader visible preventScrolling={false} className='network-login-loader' />
    </div>
  );
}

export default NetworkLogin;
